import { Overlay } from '@/components/Overlay';
import { useLoadingLogic } from '@/contexts/Loading/logic';
import React, {
  createContext,
  FC,
  PropsWithChildren,
} from 'react';

export type TLoadingContext = ReturnType<typeof useLoadingLogic>;

const noopLoading: TLoadingContext = {
  overlay: null,
  isOverlay: false,
  setOverlay: () => undefined,
};

export const LOADING_CONTEXT =
  createContext<TLoadingContext>(noopLoading);

export const LoadingProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const value = useLoadingLogic();

  return (
    <LOADING_CONTEXT.Provider value={value}>
      <Overlay />
      {children}
    </LOADING_CONTEXT.Provider>
  );
};
